import type { ReactNode } from "react"

export function PageHeader({
  title,
  description,
  extra,
}: {
  title: ReactNode
  description?: ReactNode
  extra?: ReactNode
}) {
  return (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 16, marginBottom: 16 }}>
      <div style={{ minWidth: 0, flex: 1 }}>
        <h1 style={{ margin: 0, fontSize: 20, fontWeight: 650, color: "var(--csbi-ink-primary)" }}>{title}</h1>
        {description && (
          <p style={{ margin: "4px 0 0", fontSize: 13, color: "var(--csbi-ink-secondary)", lineHeight: 1.6 }}>
            {description}
          </p>
        )}
      </div>
      {extra && <div style={{ marginLeft: "auto", flex: "0 0 auto" }}>{extra}</div>}
    </div>
  )
}

export function SectionTitle({ children }: { children: ReactNode }) {
  return (
    <h2
      style={{
        margin: "20px 0 10px",
        fontSize: 14,
        fontWeight: 650,
        color: "var(--csbi-ink-secondary)",
      }}
    >
      {children}
    </h2>
  )
}
